import React from 'react';
import { BrowserRouter as Router,Route, Routes, useLocation  } from 'react-router-dom';
import MainPage from './pages/MainPage';
import Navbar from './components/navbar/Navbar';
import FilmsPage from './pages/FilmsPage';
import ContactPage from './pages/ContactPage';
import AboutUsPage from './pages/AboutUsPage';
import FormPage from './pages/FormPage';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/footer/Footer'
import SuccessfulPaymentPage from './pages/SuccessfulPaymentPage';
import RejectedPage from './pages/RejectedPage';
import ResultPage from './pages/ResultPage';
import PrivacyPage from './pages/PrivacyPage';
import PaymentPage from './components/main/PaymentPage';

const App = () => {
  const location = useLocation();

  const renderNavbar = () => {
    const showNavbar = ['/', '/films', '/events', '/about-us', '/contact'];
    return showNavbar.includes(location.pathname) && <Navbar />;
  };

  const renderFooter = () => {
    const showFooter = ['/', '/films', '/events', '/about-us', '/contact'];
    return showFooter.includes(location.pathname) && <Footer />;
  };

  return (
    <>
      {renderNavbar()}
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<MainPage />} />
        <Route path='/films' element={<FilmsPage />} />
        {/* <Route path='/events' element={<EventsPage />} /> */}
        <Route path='/about-us' element={<AboutUsPage />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/form' element={<FormPage />} />
        <Route path='/successful' element={<SuccessfulPaymentPage />} />
        <Route path='/error' element={<RejectedPage />} />
        <Route path='/result' element={<ResultPage />} />
        <Route path='/privacy-policy' element={<PrivacyPage/>}/>
        <Route path='/payment' element={<PaymentPage/>}/>
      </Routes>
      {renderFooter()} 
    </>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
